import { CustomCompanyIntegrationModalService, CustomToastrAction, CONSTANTS} from '@/imports-files/components/model/custom-company-integration-modal.js';

export class CustomCompanyIntegrationModalAction
{
    constructor(setModal, setCustomEnableItems, setFlagForRerender, setApiError, formRef)
    {
        this.customCompanyIntegrationModalService   =  new CustomCompanyIntegrationModalService();
        this.customToastrAction                     =  new CustomToastrAction();
        this.setModal                               =  setModal
        this.setCustomEnableItems                   =  setCustomEnableItems
        this.setFlagForRerender                     =  setFlagForRerender 
        this.setApiError                            =  setApiError;
        this.formRef                                 =   formRef;
    }

    getSelectValue(values)
    {
        var select_values = []
        Object.keys(values).map((key, index) => { 
                                                    select_values.push({ value: key, label: values[key] })
                                                })
                                                
        return select_values;
    }

    async submitForm(values, type) {
        var result = '';
        if (type == 'Edit') {
            result = await this.customCompanyIntegrationModalService.updateCustomIntegrationsList(values);
        }
        else if (type == 'Create') {
            result = await this.customCompanyIntegrationModalService.addCustomIntegrationsList(values);
        }

        if (result.request.status == 200) {
            this.customToastrAction.setNormalToastr(result.data.success, 'success');
            this.setApiError(result.request);
            this.setCustomEnableItems(result.data.custom_integrations);
            this.setModal(false);
            this.setFlagForRerender(Math.random() * 10000);
        }
        else
        {
             this.formRef.current.setStatus(result.response.data.error);
        }
    }

    setInitialValues(data, type)
    {
        if(type=='Edit')
        {
            Object.keys(data).map((key) => {
                                               CONSTANTS.formInitialValues.custom_integration[key] = data[key] 
                                           })
        }
        else
        {
             Object.keys(CONSTANTS.formInitialValues.custom_integration).map((key) => {
                                               CONSTANTS.formInitialValues.custom_integration[key] = '';
                                                                                    })
        }

        return CONSTANTS.formInitialValues;
    }

    resetForm(formRef)
    {
        this.setFlagForRerender(Math.random() * 10000);
    }
}